import CartSVG from '@/assets/icons/cart.svg';
import MenuHamburgerSVG from '@/assets/icons/menuHamburger.svg';
import newLogo from '@/assets/icons/joybuySmallLogo.png';
import PersonSVG from '@/assets/icons/person.svg';
import HeaderAddressButton from '@/components/address/HeaderAddress';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25114';
import { saveUrlExtraParams } from '@/utils/extUrlParamsUtils';
import { observer } from 'mobx-react';
import Image from 'next/image';
import React, { useEffect } from 'react';
import styles from './mainHeader.module.scss';
import { useStores } from '@/models';
import { usePageShowObserver } from '@/hooks/usePageShowObserver';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
import { Home_Page_Code } from '@/constants/cms';

interface IMainHeader {
  mainHeaderRef?: any;
  setIsShowMainSideMenu: React.Dispatch<React.SetStateAction<boolean>>;
  disabled?: boolean;
  pageCode?: string;
}

// eslint-disable-next-line react/display-name
const MainHeader: React.FC<IMainHeader> = observer(
  ({ setIsShowMainSideMenu, mainHeaderRef, disabled, pageCode }, ref) => {
    const { cartNumStore } = useStores(); //购物车浮层数据全局管理
    const { displayCartNum, isCartNumValid } = cartNumStore;

    usePageShowObserver({
      callback: () => {
        cartNumStore.fetchCartNum(true);
      },
    });

    useEffect(() => {
      // 地推、邀请有礼归因所需参数，存储7天
      saveUrlExtraParams();
      cartNumStore.fetchCartNum();
    }, []);

    const onClickHamburgerBtn = () => {
      setIsShowMainSideMenu(true);
      sendClickTrack.Header_Category_Btn();
    };

    return (
      <div className={`${styles.mainWrap} ${disabled ? styles.disabled : ''}`} ref={mainHeaderRef}>
        <a
          onClick={onClickHamburgerBtn}
          target='_self'
          exptag={'exp|' + EXPOSURE_RECORD.Header_Category_Btn_Expo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        >
          <MenuHamburgerSVG />
        </a>
        <a
          href={'/'}
          target='_self'
          exptag={'exp|' + EXPOSURE_RECORD.Header_Joybuy_Btn_Expo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          onClick={() => {
            sendClickTrack.Header_Joybuy_Btn();
          }}
        >
          <Image width={73} height={20} src={newLogo} alt='' />
        </a>
        <div className={styles.beta}>Beta</div>
        <div
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          data-exp={JSON.stringify({
            spm: 'a0145.b002218.c00002477.Locate',
            event_id: 'Home_Locate_Expo',
            page_id: pageCode === Home_Page_Code ? 'Home_Main' : pageCode,
          })}
          onClick={() =>
            spmTrackingUtils.spmClick({
              spm: 'a0145.b002218.c00002477.Locate',
              event_id: 'Home_Locate',
              page_id: pageCode === Home_Page_Code ? 'Home_Main' : pageCode,
            })
          }
        >
          {/* 地址按钮 */}
          <HeaderAddressButton />
        </div>
        <a
          className={styles.personBtn}
          href='/profile'
          target='_self'
          exptag={'exp|' + EXPOSURE_RECORD.Header_MyJD_Btn_Expo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          onClick={() => {
            sendClickTrack.Header_MyJD_Btn();
          }}
        >
          <PersonSVG />
        </a>
        <a
          className={styles.cartBtn}
          href='/cart'
          target='_self'
          exptag={'exp|' + EXPOSURE_RECORD.Header_Addcart_Btn_Expo}
          data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
          onClick={() => {
            sendClickTrack.Header_Addcart_Btn();
          }}
        >
          <CartSVG />
          {isCartNumValid ? <span className={styles.cartNum}>{displayCartNum}</span> : null}
        </a>
      </div>
    );
  },
);

// 手动添加 displayName
MainHeader.displayName = 'MainHeader';

export default MainHeader;
